<script lang="ts" setup>
import { FormRuleType } from "~/types/element-ui/FormRuleType";
import { CallHistory } from "~/types";
import { useDialogStore } from "~/projects/cc/stores/dialogStore";

const dialogStore = useDialogStore();

const handleAddNotesFun = (done: () => void) => {
  dialogStore.setAddNoteModalVisibility(false);
  done();
};

const notesForm = reactive({
  remarks: "",
});

const submitForm = async function () {
  await dialogStore.addNote(notesForm);
};

const rules: FormRuleType = {
  remarks: [],
};

const noteRemarksRef = ref<HTMLInputElement | null>(null);
watch(
  () => dialogStore.showAddNotes,
  async (value) => {
    if (!value) return;
    await nextTick();
    console.log(noteRemarksRef.value);
    noteRemarksRef.value?.focus();
  },
);
</script>

<template>
  <div class="sm:call">
    <client-only>
      <el-dialog
        v-model="dialogStore.showAddNotes"
        :before-close="handleAddNotesFun"
        :lock-scroll="false"
        :destroy-on-close="true"
        :modal="false"
        width="35%"
        align-center
        draggable
        :show-close="false"
      >
        <template #header="{ titleId, titleClass }">
          <div class="my-header flex flex-col gap-1">
            <h4 :id="titleId" class="text-md" :class="titleClass">
              Update Call History
            </h4>
            <span class="dialog-title-subtext">
              Update the form to edit call history
            </span>
          </div>
        </template>

        <div class="p-2">
          <CallHistoriesEditForm
            :remote-edit="true"
            :show-edit-modal-header="false"
            @close="dialogStore.setAddNoteModalVisibility(false)"
          />
        </div>
      </el-dialog>
    </client-only>
  </div>
</template>

<style scoped></style>
